import {Column, HeaderProps} from 'react-table'
import {PropsWithChildren} from 'react'
import {IVoucherList} from './_model'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import VoucherActionCell from './VoucherActionCell'
import {dateFormat} from '../../../utils/helperFunction/_helper'
import {Link} from 'react-router-dom'

const voucherListColumn = (
  handleSelect: (selectType: string, id: number) => void
): ReadonlyArray<Column<IVoucherList>> => {
  return [
    {
      Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
      id: 'selection',
      Cell: ({...props}) => (
        <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
      ),
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='voucher no' className='min-w-100px' />
      ),
      id: 'voucher_no',
      accessor: 'voucher_no',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='date' className='min-w-100px' />
      ),
      id: 'created_at',
      Cell: ({...props}) => (
        <span>
          {props.data[props.row.index].created_at &&
            dateFormat(props.data[props.row.index].created_at.toString(), true)}
        </span>
      ),
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='contact name' className='min-w-100px' />
      ),
      id: 'user_full_name',
      accessor: 'user_full_name',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='invoice no' className='min-w-100px' />
      ),
      id: 'invoice_no',
      accessor: 'invoice_no',
      Cell: ({...props}) => (
        <Link to={`/billing/invoice/${props.data[props.row.index].invoice_id}`}>
          {props.data[props.row.index].invoice_no}
        </Link>
      ),
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='amount' className='min-w-100px' />
      ),
      id: 'amount',
      accessor: 'amount',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='due' className='min-w-100px' />
      ),
      id: 'due',
      accessor: 'due',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IVoucherList>>) => (
        <CustomHeader tableProps={props} title='' className='min-w-100px text-end' />
      ),
      id: 'action',
      Cell: ({...props}) => (
        <VoucherActionCell handleSelect={handleSelect} voucher={props.data[props.row.index]} />
      ),
    },
  ]
}

export default voucherListColumn
